import breadcrumbTemplate from 'app/angularjs/common/breadcrumb/breadcrumb.html';
import cmsArticlesListTemplate from './cms_articles-list.html';
import cmsArticlesEditTemplate from './cms_articles-edit.html';


angular.module("cmsArticles", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('cms_articles', {
                url: "/cms_articles",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: breadcrumbTemplate,
            })
            .state('cms_articles.list', {
                url: "/list",
                controller: "CmsArticlesListCtrl",
                template: cmsArticlesListTemplate,
                requiredPermission: ["CMS_CATEGORIES_READ"]
            })
            .state('cms_articles.edit', {
                url: "/edit/:id",
                controller: "CmsArticlesEditCtrl",
                template: cmsArticlesEditTemplate,
                params: {
                    'id': "",
                    'parent_id': "",
                    'standalone': false,
                },
                requiredPermission: ["CMS_CATEGORIES_READ"]
            })
    }])
    ;